// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thumbnail_qTqb4 {
  width: 100%;
  max-width: 175px;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.23);
}
.thumbnail_qTqb4 img {
  width: 100%;
}
.thumbnailSmall_qYtH_ {
  height: 150px;
}
.thumbnailSmall_qYtH_ img {
  height: 100%;
}
.checkbox_ZZfMX {
  width: 15px;
  height: 15px;
}
.code_Mwq6n {
  max-width: 100%;
  overflow-x: scroll;
}
.sliderGroup_hLF1W {
  padding-top: 12px;
  padding-bottom: 12px;
}
.sliderGroup_hLF1W .slider_lJxv4[type="range"] {
  width: initial;
}
`, "",{"version":3,"sources":["webpack://./src/editors/geotile/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB","sourcesContent":[".thumbnail {\n  width: 100%;\n  max-width: 175px;\n  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.23);\n}\n.thumbnail img {\n  width: 100%;\n}\n.thumbnailSmall {\n  height: 150px;\n}\n.thumbnailSmall img {\n  height: 100%;\n}\n.checkbox {\n  width: 15px;\n  height: 15px;\n}\n.code {\n  max-width: 100%;\n  overflow-x: scroll;\n}\n.sliderGroup {\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n.sliderGroup .slider[type=\"range\"] {\n  width: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"thumbnail": `thumbnail_qTqb4`,
	"thumbnailSmall": `thumbnailSmall_qYtH_`,
	"checkbox": `checkbox_ZZfMX`,
	"code": `code_Mwq6n`,
	"sliderGroup": `sliderGroup_hLF1W`,
	"slider": `slider_lJxv4`
};
export default ___CSS_LOADER_EXPORT___;
